import classNames from 'classnames';
import React from 'react';
import LoadingSpinnerLight from 'src/common/components/loading-spinner/light';
import { RenderMode } from '../../types';

type Props = {
  loading: boolean;
  selected: boolean;
  renderMode: RenderMode;
};

export const BlockHoverLayer = ({ loading, selected, renderMode }: Props) => {
  let backgroundClassName = '';
  if (renderMode === 'player' || renderMode === 'thumbnail') {
    backgroundClassName = 'bg-neue-gray-0/5';
  } else if (renderMode === 'editor') {
    if (selected) {
      backgroundClassName = 'bg-transparent';
    } else {
      backgroundClassName = 'bg-neue-gray-0/5 group-hover/block:bg-neue-gray-0/10';
    }
  }
  return (
    <div
      className={classNames(
        'absolute inset-0 pointer-events-none rounded-2xl transition-colors',
        {
          'opacity-0': loading,
          'opacity-100': !loading,
        },
        backgroundClassName
      )}
    ></div>
  );
};
